import React from 'react';
import { Button } from 'antd';
import { Sun, Moon } from 'lucide-react';
import { useThemeStore } from '../store/themeStore';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useThemeStore();

  return (
    <Button
      type="text"
      onClick={toggleTheme}
      icon={theme === 'light' ? <Moon className="h-5 w-5" /> : <Sun className="h-5 w-5" />}
      className="flex items-center justify-center hover:bg-opacity-10"
      style={{
        color: 'var(--text-secondary)',
      }}
      title={theme === 'light' ? '다크 모드로 전환' : '라이트 모드로 전환'}
    />
  );
};

export default ThemeToggle;